/* --------------------------------------------------------------------------------------
   xwKeyboard.directive.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved. 
   
   Copyright protection claimed includes all forms and matters of copyrightable material 
   and information now allowed by statutory or judicial law or hereinafter granted, 
   including without limitation, material generated from the software programs which 
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

/*eslint semi: ["error", "never"]*/
 export class xwKeyboard {
  /*@ngInject*/
  constructor () {
    this.restrict = 'A'
    this.scope = {}
  }
  link(scope, elem, attrs) {

    let options = {
      layout: attrs.layout,
      theme: attrs.theme,
      restrictInput: attrs.restrictInput,
      preventPaste: attrs.preventPaste,
      initialPlaceholder: attrs.initialPlaceholder,
      alwaysOpen: attrs.alwaysOpen,
      appendTo: attrs.appendTo,
      backgroundSlide: attrs.backgroundSlide,
      maxLength: attrs.maxLength,
      appendLocally: attrs.appendLocally
    }
    elem.first().xrxkeyboard(options)

    scope.$on('$destroy', () => {
      scope = null
    })
    elem.on('$destroy', () => {
      elem.first().xrxkeyboard('destroy')
      elem = null
    })
  }
  static directiveFactory() {
    xwKeyboard.instance = new xwKeyboard()
    return xwKeyboard.instance
  }
}



// WEBPACK FOOTER //
// ./src/app/xrxWrappers/xwKeyboard.directive.js